import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import TopForm from '../../img/top-fon.jpg';

const EventThemesBase = ({ themesData }) => {

    if (!themesData) return null;

    const { theme_title, theme_subtitle, theme_list } = themesData;

    const topListStyle = "flex flex-wrap mb-6 relative";
    const beforeListCreative = "absolute top-0 left-0 w-[40px] h-[40px] bg-[#F3FF80] z-10 rounded-full z-10";
    const LinesStyle = "absolute left-[17px] -bottom-[30px] h-full w-1 bg-[#F3FF80]";

    return (
        <section className="mb-20">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2">
                <div className="flex justify-center lg:justify-end">
                    <div className="w-[90%] max-w-screen-sm relative">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl">{theme_subtitle}</h6>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h2 className="text-4xl uppercase mb-6">{theme_title}</h2>
                        </ScrollAnimation>

                        {theme_list.map((theme, index) => (
                            <div className={topListStyle}>
                                <div className="w-[40px] h-[40px] mr-[15px] z-20 flex justify-center items-center text-xl">
                                    <span>{index + 1}</span>
                                </div>
                                <div className="w-[calc(100%-55px)]">
                                    <ScrollAnimation animateIn="animate__fadeInUp">
                                        <h3 className="uppercase mb-1">{theme.title}</h3>
                                        <p>{theme.desc}</p>
                                    </ScrollAnimation>
                                </div>
                                <div className={beforeListCreative}></div>
                                {index !== theme_list.length - 1 && <div className={LinesStyle}></div>}
                            </div>
                        ))}
                    </div>
                </div>
                {/*<div className="!bg-cover !bg-right-center" style={{background: "url(" + TopForm + ")"}}></div>*/}
                <div className="h-full"><img src={TopForm} className="object-cover h-full w-auto sm:rounded-l-2xl" alt="Теми BWS"/></div>
            </div>
        </section>
    )
}

export default EventThemesBase;